/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Whether statistics/analytics consent has been granted (Cookiebot / Shopify Customer Privacy).
   * @returns {boolean}
   */
  static #statisticsAllowed() {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return !!cp.analyticsProcessingAllowed();
    } catch (e) {}
    try {
      if (window.Cookiebot && window.Cookiebot.consent && typeof window.Cookiebot.consent.statistics !== 'undefined')
        return !!window.Cookiebot.consent.statistics;
    } catch (e) {}
    return false; // im Zweifel: nicht speichern
  }

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    // Ohne Statistik-Einwilligung nichts speichern (+ evtl. Altbestand entfernen)
    if (!this.#statisticsAllowed()) {
      this.clearProducts();
      return;
    }

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}
